import { render, staticRenderFns } from "./FilesDatatable.vue?vue&type=template&id=7589e003&scoped=true&"
import script from "./FilesDatatable.vue?vue&type=script&lang=js&"
export * from "./FilesDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589e003",
  null
  
)

export default component.exports